module.exports = __webpack_public_path__ + "img/op5.754690e1.png";